import styled from "styled-components";

const Text = styled.p`
  font-weight: 500;
  font-size: 14px;
  text-transform: none;
  font-style: normal;
  opacity: 1;
  color: rgb(53, 63, 82);
`;

export default Text;
